import React, { createContext, useContext, useState, useEffect } from 'react';
import { adminAuthApi } from '../services/adminApi';

const AdminContext = createContext(null);

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('admin_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      if (token) {
        try {
          const adminData = await adminAuthApi.getMe();
          setAdmin(adminData);
        } catch (error) {
          console.error('Admin auth check failed:', error);
          setToken(null);
          setAdmin(null);
          localStorage.removeItem('admin_token');
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, [token]);

  const login = async (email, password) => {
    try {
      const response = await adminAuthApi.login(email, password);
      localStorage.setItem('admin_token', response.access_token);
      setToken(response.access_token);
      setAdmin(response.user);
      return { success: true };
    } catch (error) {
      const message = error.response?.data?.detail || 'Giriş başarısız';
      return { success: false, error: message };
    }
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    setToken(null);
    setAdmin(null);
  };

  return (
    <AdminContext.Provider value={{
      admin,
      token,
      loading,
      login,
      logout,
      isAuthenticated: !!admin
    }}>
      {children}
    </AdminContext.Provider>
  );
};
